import { defineMessages } from 'react-intl';
import dividerHorizontalSVG from '@plone/volto/icons/divide-horizontal.svg';
import View from './View';
import Edit from './Edit';

defineMessages({
  divider: {
    id: 'Divider',
    defaultMessage: 'Divider',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.dividerLine = {
    id: 'dividerLine',
    title: 'Divider',
    group: 'layout',
    icon: dividerHorizontalSVG,
    view: View,
    edit: Edit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
